module.exports = __webpack_public_path__ + "img/payment_succeed.48e17e1d.svg";